import { IHisInformationApplicable, instanceOfIHisInformationApplicable } from "./IHisInformationApplicable";

/** HIS情報の選択画面を表示可能な項目のインターフェース */
export interface IHisInformationSelectInputable extends IHisInformationApplicable {
  isHisInfoSelectInputable: boolean;
}

export function instanceOfIHisInformationSelectInputable(instance: any): instance is IHisInformationSelectInputable {
  return (instance != null)
    && (instance.isHisInfoSelectInputable !== undefined)
    && instanceOfIHisInformationApplicable(instance);
}
